import { render, staticRenderFns } from "./lazyImg.vue?vue&type=template&id=63f25f9b&scoped=true&"
import script from "./lazyImg.vue?vue&type=script&lang=js&"
export * from "./lazyImg.vue?vue&type=script&lang=js&"
import style0 from "./lazyImg.vue?vue&type=style&index=0&id=63f25f9b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f25f9b",
  null
  
)

export default component.exports